export async function loadFileAsString(file) {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();

    fileReader.addEventListener("load", (e) => {
      const base64String = e.target.result;
      const str = atob(base64String.split(",")[1]); // Decode the Base64 string
      // JSON.parse(str); // Parse the JSON string
      resolve(str);
    });
    fileReader.readAsDataURL(file); // File()
  });
}

// File Helper
export function loadUrl(file) {
  const fileUrl = URL.createObjectURL(file);
  return fileUrl;
}
